/**
 * "OPEN THE CALL" (ops #13, `docs/seams/phone.md` section 7.2): the way onto the per-call page from
 * the Calls tab, a household's history and an enquiry a call opened.
 *
 * Drawn only for an owner or a manager, because the page is the phone system's operator view and the
 * server refuses it to everybody else; drawing it for the office role would be a door that answers
 * 403. That is UX: the server's guard is the control. And drawn only beside a provider's call id,
 * `CA` and thirty-two hex digits, the one pattern the server holds a sid to, so no link leads to a
 * page that can only say "No such call".
 */
import { Link } from 'react-router-dom';
import { isCallSid } from '@fk/shared';
import type { Me } from '../api.ts';

/** Whether this person may open a call's page at all: the owners and the managers. */
export function opensCallPages(me: Pick<Me, 'role'>): boolean {
  return me.role === 'owner' || me.role === 'manager';
}

export function OpenTheCall({
  me,
  callSid,
  className = '',
}: {
  me: Pick<Me, 'role'>;
  callSid: string | null;
  className?: string;
}) {
  if (!opensCallPages(me) || !isCallSid(callSid)) return null;
  return (
    <Link
      to={`/calls/${callSid}`}
      className={`inline-flex min-h-11 desk:min-h-9 items-center text-sm underline underline-offset-2 ${className}`}
    >
      Open the call
    </Link>
  );
}
